"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var utils_1 = require("../../../../utils");

var __1 = require("../../..");

var styles = tslib_1.__importStar(require("./OfferCardVertical.style"));

var CardLink_1 = tslib_1.__importDefault(require("../../CardLink"));

function OfferCardVertical(_ref) {
  var className = _ref.className,
      id = _ref.id,
      title = _ref.title,
      category = _ref.category,
      price = _ref.price,
      _ref$isReservable = _ref.isReservable,
      isReservable = _ref$isReservable === void 0 ? true : _ref$isReservable,
      unavailableReason = _ref.unavailableReason,
      _ref$immediateConfirm = _ref.immediateConfirm,
      immediateConfirm = _ref$immediateConfirm === void 0 ? false : _ref$immediateConfirm,
      _ref$bestPrice = _ref.bestPrice,
      bestPrice = _ref$bestPrice === void 0 ? false : _ref$bestPrice,
      _ref$isSwipe = _ref.isSwipe,
      isSwipe = _ref$isSwipe === void 0 ? false : _ref$isSwipe,
      _ref$isWished = _ref.isWished,
      isWished = _ref$isWished === void 0 ? false : _ref$isWished,
      aTagAttrs = _ref.aTagAttrs,
      href = _ref.href,
      isCSRLink = _ref.isCSRLink,
      imgSrc = _ref.imgSrc,
      onClick = _ref.onClick,
      onClickIsWished = _ref.onClickIsWished,
      onClickIsNotWished = _ref.onClickIsNotWished;

  var _react_1$useState = react_1.useState(isWished),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isWishedState = _react_1$useState2[0],
      setWished = _react_1$useState2[1];

  function handleClick() {
    onClick && onClick();
  }

  function handleClickWish() {
    if (isWishedState) {
      onClickIsNotWished && onClickIsNotWished(id, setWished);
      return;
    }

    onClickIsWished && onClickIsWished(id, setWished);
  }

  return jsx_runtime_1.jsx(CardLink_1.default, Object.assign({}, aTagAttrs, {
    isCSRLink: isCSRLink,
    href: href || (aTagAttrs ? aTagAttrs.href : '')
  }, {
    children: jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.conatiner(isSwipe),
      className: className,
      onClick: handleClick
    }, {
      children: [jsx_runtime_1.jsx(__1.WishlistIcon, {
        css: styles.wishlistHeart,
        isWished: isWishedState,
        onClick: handleClickWish
      }, void 0), jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.coverImage
      }, {
        children: [jsx_runtime_1.jsx(__1.ResponsiveImage, {
          css: styles.imageWrapper,
          src: imgSrc,
          alt: "offer card image"
        }, void 0), bestPrice && jsx_runtime_1.jsx("span", Object.assign({
          css: styles.bestPrice
        }, {
          children: "\uCD5C\uC800\uAC00 \uBCF4\uC7A5\uC81C"
        }), void 0)]
      }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.content
      }, {
        children: [jsx_runtime_1.jsxs("div", {
          children: [jsx_runtime_1.jsx("div", Object.assign({
            css: styles.category
          }, {
            children: category
          }), void 0), jsx_runtime_1.jsx("div", Object.assign({
            css: styles.title
          }, {
            children: title
          }), void 0)]
        }, void 0), jsx_runtime_1.jsx("div", Object.assign({
          css: styles.price
        }, {
          children: !isReservable ? unavailableReason || '객실 판매 완료' : jsx_runtime_1.jsxs(react_1.Fragment, {
            children: [utils_1.toCurrency(price), "\uC6D0", immediateConfirm && jsx_runtime_1.jsx(__1.Icon, {
              name: "ic_instantbooking_7x12_gray_700",
              alt: "instant offer"
            }, void 0)]
          }, void 0)
        }), void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
}

exports.default = react_1.memo(OfferCardVertical);